export type PackageQuantityBounds = {
  minSaleTariffQuantity?: number | null;
  maxSaleTariffQuantity?: number | null;
};

export function resolvePackageQuantityRange(products: PackageQuantityBounds[]): { min: number; max: number } {
  if (!products.length) {
    return { min: 1, max: 10 };
  }

  const mins = products.map((product) => product.minSaleTariffQuantity ?? 1);
  const maxes = products.map((product) => product.maxSaleTariffQuantity ?? 10);
  // A per-product min of 0 means "no extra floor on this product", but the package still needs at
  // least one ticket — never expose min: 0 to step validation or cart replication.
  const min = Math.max(1, ...mins);
  const max = Math.min(...maxes);

  return { min, max };
}
